import { Box, BoxProps, TableProps } from '@amzn/awsui-components-core';
import { ContentWorkflow, UserProfile } from '@amzn/awscat-pattern-library-service-model';
import React from 'react';
import { IMplServiceClient } from '../../api/IMplServiceClient';
import { MplServiceClientFactory } from '../../api/MplServiceClientFactory';
import ContentWorkflowTable from '../workflow-viewer/ContentWorkflowTable';

interface ContentTableProps {
  wrapperPadding?: BoxProps.Spacing;
  userProfile: UserProfile;
}

interface ContentTableState {
  isLoading: boolean;
  workflows: ContentWorkflow[];
}

class ContentTable extends React.Component<ContentTableProps, ContentTableState> {
  protected readonly mplServiceClient: IMplServiceClient;

  // @ts-expect-error TS2564 - strict migration
  protected tableHeader: string;
  // @ts-expect-error TS2564 - strict migration
  protected tableId: string;
  // @ts-expect-error TS2564 - strict migration
  protected columnDefinitions: Array<TableProps.ColumnDefinition<ContentWorkflow>>;
  protected allowedControlActions = [];
  protected allowedFilterTypes = [];
  // @ts-expect-error TS7008 - strict migration
  protected selectionType;

  // @ts-expect-error TS7006 - strict migration
  constructor(props) {
    super(props);
    this.mplServiceClient = MplServiceClientFactory.create();

    this.state = {
      isLoading: true,
      workflows: [],
    };
  }

  public async componentDidMount() {
    if (this.validateUserRole()) {
      this.loadData();
    }
  }

  public render() {
    if (!this.validateUserRole()) {
      return null;
    }

    const { wrapperPadding } = this.props;
    const { isLoading, workflows } = this.state;

    const contentTable = (
      <Box padding={wrapperPadding}>
        <ContentWorkflowTable
          header={this.tableHeader}
          tableId={this.tableId}
          loading={isLoading}
          workflows={workflows}
          columnDefinitions={this.columnDefinitions}
          onRefreshClick={this.loadData}
          allowedControlActions={this.allowedControlActions}
          allowedFilterTypes={this.allowedFilterTypes}
          selectionType={this.selectionType}
        />
      </Box>
    );

    return contentTable;
  }

  protected loadData = async () => {
    this.setState({
      isLoading: true,
    });

    const workflows = await this.fetchWorkflows();

    this.setState({
      isLoading: false,
      workflows,
    });
  };

  protected fetchWorkflows(): Promise<ContentWorkflow[]> {
    // @ts-expect-error TS2322 - strict migration
    return null;
  }

  protected validateUserRole(): boolean {
    return false;
  }
}

export default ContentTable;
